import { useMemo } from "react";
import type { UIMessage } from "@ai-sdk/react";

export interface OAuthPromptData {
  connectionId: string;
  connectionName: string;
  authUrl: string;
}

interface OAuthDataPart {
  type: "data-oauth_required";
  data: { connectionId: string; connectionName: string; authUrl: string };
}

function isOAuthPart(part: unknown): part is OAuthDataPart {
  return (
    typeof part === "object" &&
    part !== null &&
    (part as Record<string, unknown>).type === "data-oauth_required"
  );
}

export function useChatOAuth(messages: UIMessage[] | undefined): OAuthPromptData[] {
  return useMemo(() => {
    if (!messages || messages.length === 0) return [];
    const seen = new Set<string>();
    const prompts: OAuthPromptData[] = [];
    for (const msg of messages) {
      if (!msg.parts) continue;
      for (const part of msg.parts) {
        if (isOAuthPart(part)) {
          const { connectionId, connectionName, authUrl } = part.data;
          if (!seen.has(connectionId)) {
            seen.add(connectionId);
            prompts.push({ connectionId, connectionName, authUrl });
          }
        }
      }
    }
    return prompts;
  }, [messages]);
}
